/*
 * @Author: Wang Wenmao
 * @Date: 2023-11-08 14:59:42
 * @LastEditors: Wang Wenmao
 * @LastEditTime: 2023-12-22 15:27:08
 * @Description: 微信直播间数据-表格部分
 */

import React, { useState, useEffect } from 'react';
import { message, Table, Form, Button, Input, Select, Icon } from 'antd';
import { services } from '@comall-backend-builder/core';
import moment from 'moment';
import { errorHandle } from '../../services';
import './index.less';
const api = services.api;

const broadcastStatusList = {
    101: '直播中',
    102: '未开始',
    103: '已结束',
};

export const Index = (props) => {
    const { form } = props;
    const { getFieldsValue, getFieldDecorator, resetFields } = form;
    const columns = [
        {
            title: '编号',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '直播时间',
            dataIndex: 'broadcastTime',
            key: 'broadcastTime',
            render: (text: any) => moment(text).format('YYYY.MM.DD'),
        },
        {
            title: '直播间信息',
            dataIndex: 'roomName',
            key: 'roomName',
        },
        {
            title: '直播间状态',
            dataIndex: 'broadcastStatus',
            key: 'broadcastStatus',
            render: (text: any) => broadcastStatusList[text],
        },
        {
            title: '操作',
            dataIndex: 'x',
            key: 'x',
            render: (text: any, record: any) => (
                <Button type="link" onClick={() => handleExport(record)}>
                    导出
                </Button>
            ),
        },
    ];

    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [searchNum, setSearchNum] = useState(0);
    const [pagination, setPagination] = useState({
        page: 1,
        per_page: 10,
        total: 0,
    });

    useEffect(() => getTableData(), [pagination.page, pagination.per_page, searchNum]);

    const getTableData = () => {
        setLoading(true);
        let params = {
            page: pagination.page,
            per_page: pagination.per_page,
            ...getFieldsValue(),
        };

        api.get(params, { apiPath: '/wechatBroadcast' })
            .then((res: any) => {
                setDataSource(res.result);
                setPagination({
                    ...pagination,
                    total: res.totalNum,
                });
            })
            .catch(errorHandle)
            .finally(() => setLoading(false));
    };

    const exportWechatBroadcast = (ids: any[]) => {
        const apiPath = '/wechatBroadcast/exportWechatBroadcast';
        api.post({ ids }, { apiPath })
            .then(() => {
                message.success('导出成功，请到 报表管理 - 报表导出管理 中查看');
                setSelectedRowKeys([]);
            })
            .catch(errorHandle);
    };

    const handleSearch = (type: string) => {
        if (type === '1') {
            resetFields();
            setPagination({ ...pagination, page: 1 });
        }
        let index = searchNum;
        index++;
        setSearchNum(index);
    };

    const handleExport = (item: any) => {
        if (selectedRowKeys.length) {
            exportWechatBroadcast(selectedRowKeys);
        } else {
            exportWechatBroadcast([item.id]);
        }
    };

    const tableProps: any = {
        rowKey: 'id',
        style: { marginTop: 20 },
        columns,
        dataSource,
        loading,
        rowSelection: {
            type: 'checkbox',
            selectedRowKeys,
            onChange: (_selectedRowKeys: any) => setSelectedRowKeys(_selectedRowKeys),
        },
        pagination: {
            current: pagination.page,
            pageSize: pagination.per_page,
            total: pagination.total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '15', '20'],
            showTotal: (_total: number) => `共 ${_total} 条记录`,
            onChange: (page: number, per_page: number) =>
                setPagination({ ...pagination, page, per_page }),
            onShowSizeChange: (_: number, per_page: number) =>
                setPagination({ ...pagination, page: 1, per_page }),
        },
    };
    return (
        <div className="live-wechat-data-table">
            <Form layout="inline">
                <Form.Item label="直播间名称">
                    {getFieldDecorator('roomName', { initialValue: '' })(
                        <Input placeholder="请输入直播间名称" />
                    )}
                </Form.Item>
                <Form.Item label="直播间状态">
                    {getFieldDecorator('broadcastStatus', { initialValue: undefined })(
                        <Select allowClear style={{ width: 200 }} placeholder="请选择直播间状态">
                            <Select.Option value={101}>直播中</Select.Option>
                            <Select.Option value={102}>未开始</Select.Option>
                            <Select.Option value={103}>已结束</Select.Option>
                        </Select>
                    )}
                </Form.Item>
                <Form.Item>
                    <Button type="primary" onClick={() => handleSearch('0')}>
                        查询
                    </Button>
                    <Button style={{ marginLeft: 10 }} onClick={() => handleSearch('1')}>
                        重置
                    </Button>
                </Form.Item>
            </Form>
            {selectedRowKeys.length ? (
                <div className="live-wechat-data-table-msg">
                    <Icon type="info-circle" theme="filled" style={{ color: '#448EF7' }} />
                    <div style={{ marginLeft: 10 }}>
                        已选择
                        <span style={{ color: '#448EF7', margin: '0 5px' }}>
                            {selectedRowKeys.length}
                        </span>
                        项
                    </div>
                    <Button
                        style={{ marginLeft: 20 }}
                        type="link"
                        onClick={() => setSelectedRowKeys([])}
                    >
                        清空
                    </Button>
                </div>
            ) : null}
            <Table {...tableProps} />
        </div>
    );
};

export const LiveWechatDataTable = Form.create<any>()(Index);
